import { render } from "./searchPage.vue?vue&type=template&id=dbb88874&scoped=true"
import script from "./searchPage.vue?vue&type=script&lang=js"
export * from "./searchPage.vue?vue&type=script&lang=js"

import "./css/antd.css?vue&type=style&index=0&lang=css"
import "./searchPage.vue?vue&type=style&index=1&id=dbb88874&scoped=true&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb88874"]])

export default __exports__